// src/web/CertificateVerification.jsx

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const CertificateVerification = () => {

  const { certificateId } = useParams();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [valid, setValid] = useState(false);

  useEffect(() => {

    const verify = async () => {

      try {

        const res = await fetch(
          `${import.meta.env.VITE_API_URL}/certifications/verify/${certificateId}`
        );

        const result = await res.json();

        setValid(result.valid);
        setData(result);

      } catch (error) {

        setValid(false);

      }

      setLoading(false);

    };

    verify();

  }, [certificateId]);

  if (loading) {
    return (
      <div className="certificate-verification loading">
        <p>Verifying certificate...</p>
      </div>
    );
  }

  if (!valid) {
    return (
      <div className="certificate-verification invalid">
        <h1>Certificate not valid</h1>
        <p>This certificate could not be verified.</p>
      </div>
    );
  }

  return (

    <div className="certificate-verification">

      <div className="verification-card">

        <div className="verification-header">

          <img
            src="/logo.png"
            alt="All-Voiced"
            className="verification-logo"
          />

          <div className="verified-badge">
            ✓ Certificate Verified
          </div>

        </div>

        <div className="verification-content">

          <h2>{data.trackName}</h2>

          <p className="verification-level">
            Level: {data.level}
          </p>

          <div className="verification-info">

            <p>
              <strong>Certificate ID</strong><br />
              {data.certificateId}
            </p>

            <p>
              <strong>Score</strong><br />
              {data.scorePercentage}%
            </p>

            <p>
              <strong>Status</strong><br />
              {data.passed ? "PASS" : "FAIL"}
            </p>

            <p>
              <strong>Issued</strong><br />
              {new Date(data.issuedAt).toLocaleDateString()}
            </p>

          </div>

        </div>

        <div className="verification-footer">

        <button
            className="certificate-download-btn"
            onClick={() => {

            window.open(
                `${import.meta.env.VITE_API_URL}/certifications/certificate/${data.certificateId}/download`,
                "_blank"
            );

            }}
        >
            Download original certificate
        </button>
        <button
            className="certificate-linkedin-btn"
            onClick={() => {

                const issuedDate = new Date(data.issuedAt);

                const year = issuedDate.getFullYear();
                const month = issuedDate.getMonth() + 1;

                const verificationUrl =
                `${window.location.origin}/verify/${data.certificateId}`;

                const linkedinUrl =
                "https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME" +
                `&name=${encodeURIComponent(data.trackName)}` +
                `&organizationName=${encodeURIComponent("All-Voiced")}` +
                `&issueYear=${year}` +
                `&issueMonth=${month}` +
                `&certUrl=${encodeURIComponent(verificationUrl)}` +
                `&certId=${encodeURIComponent(data.certificateId)}`;

                window.open(linkedinUrl, "_blank");

            }}
            >
            Add to LinkedIn profile
        </button>

        <p>
            This certificate has been verified through the official
            All-Voiced certification registry.
        </p>

        </div>

      </div>

    </div>

  );
};

export default CertificateVerification;